export const PASSWORD_PLACEHOLDER = "********";
